<script setup lang="ts">
import { RouterView } from "vue-router";
import AuthHeader from "./auth/AuthHeader.vue";
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <AuthHeader />
    <div class="relative flex flex-grow">
      <main class="flex-1 w-full">
        <RouterView :key="$route.path" v-slot="{ Component }">
          <template v-if="Component">
            <Transition name="fade" mode="out-in" appear>
              <component :is="Component" />
            </Transition>
          </template>
        </RouterView>
      </main>
    </div>
  </div>
</template>
